import ClassNames from "classnames";
import { FunctionComponent, MouseEvent } from "react";
import tinycolors from "tinycolor2";
import mainMenuStyles from "../stylesheets/components/main-menu.module.css";
import {
  ColorScheme,
  Language,
  MainMenuItem,
  PageState,
  TopHeaderVariant,
} from "../types/index.js";
import { css } from "../utils/emotion.js";
import MainMenuList from "./MainMenuList.js";

interface Props {
  menuItems: MainMenuItem[];
  isPreview: boolean;
  pages: PageState;
  languageId: Language;
  scheme: ColorScheme;
  onMenuItemClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  menuLevel?: number;
  topHeaderVariant: TopHeaderVariant;
  activePagePath: string[];
  hasHeaderImage: boolean;
  className?: string;
  absolutePositioning: boolean;
  fallbackLanguageId: Language | undefined;
}

const PriorityNavigation: FunctionComponent<Props> = ({
  isPreview,
  languageId,
  menuItems,
  pages,
  scheme,
  topHeaderVariant,
  activePagePath,
  hasHeaderImage,
  className,
  absolutePositioning,
  fallbackLanguageId,
}) => {
  const wrapperStyleClass = css({
    color: scheme.main.text,
    backgroundColor:
      topHeaderVariant === "below-header-nav"
        ? hasHeaderImage
          ? tinycolors(scheme.main.background).setAlpha(0.75).toRgbString()
          : tinycolors(scheme.main.background).darken(5).toRgbString()
        : undefined,
  });

  return (
    <div
      className={ClassNames(
        mainMenuStyles.MainMenu__Wrapper,
        wrapperStyleClass,
        className,
        {
          [mainMenuStyles["MainMenu__Wrapper--absolute"]]: absolutePositioning,
        },
      )}
    >
      <nav className={mainMenuStyles.MainMenu__Container}>
        <MainMenuList
          isPreview={isPreview}
          languageId={languageId}
          menuItems={menuItems}
          pages={pages}
          scheme={scheme}
          topHeaderVariant={topHeaderVariant}
          activePagePath={activePagePath}
          fallbackLanguageId={fallbackLanguageId}
          lastItemRightAlign={true}
          repeatFirstLevelItem={true}
        />
      </nav>
    </div>
  );
};

export default PriorityNavigation;
